import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

import { NkStack } from '@/core/components';
import DashboardNavigation from '@/entities/app/components/navigation/DashboardNavigation.vue';
import SubNavigation from '@/entities/app/components/subnavigation/SubNavigation.vue';

import {
  NAVIGATION_HEIGHT,
  SUBNAVIGATION_HEIGHT,
} from '@/entities/app/components/navigation/navigation.styled';
import UserUpdateStatusModal from '@/entities/user/components/UserUpdateStatusModal.vue';
import { useGetCurrentUserQuery } from '@/entities/user/hooks';


export default /*#__PURE__*/_defineComponent({
  __name: 'InspectionLayout',
  setup(__props) {

const { data: user } = useGetCurrentUserQuery();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NkStack), {
    spacing: 0,
    class: "h-screen"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(DashboardNavigation)
      ]),
      _createElementVNode("div", null, [
        _createVNode(SubNavigation)
      ]),
      _createElementVNode("div", {
        class: "overflow-y-auto overflow-x-hidden flex-1",
        style: _normalizeStyle({ height: `calc(100vh - ${_unref(NAVIGATION_HEIGHT) + _unref(SUBNAVIGATION_HEIGHT)})`})
      }, [
        _renderSlot(_ctx.$slots, "default"),
        (_unref(user)?.status == 0)
          ? (_openBlock(), _createBlock(UserUpdateStatusModal, { key: 0 }))
          : _createCommentVNode("", true)
      ], 4)
    ]),
    _: 3
  }))
}
}

})